import { type PropsWithChildren } from 'react';

import { useNameAccessor } from '../context/NameAccessorContext.js';
import { useTreeMapAggregationData } from '../context/TreeMapAggregationDataContext.js';
import { TreeMapHighlightingMapContext } from '../context/TreeMapHighlightingMapContext.js';
import { getHighlightingMap } from '../utils/get-highlighting-map.js';

export const TreeMapHighlightingMapProvider = (props: PropsWithChildren) => {
  const { children } = props;
  const nameAccessor = useNameAccessor();
  const { dataForHighlighting } = useTreeMapAggregationData();
  const highlightingMap = getHighlightingMap(dataForHighlighting, nameAccessor);

  return (
    <TreeMapHighlightingMapContext.Provider value={highlightingMap}>
      {children}
    </TreeMapHighlightingMapContext.Provider>
  );
};

TreeMapHighlightingMapProvider['displayName'] =
  'TreeMapHighlightingMapProvider';
